import TianDingDividerComponent from "./divider.vue";

export default {
  install(Vue, PluginOptions = {}) {
    const Constructor = Vue.extend(TianDingDividerComponent);
    Vue.component('td-divider', Constructor);
  }
}



// WEBPACK FOOTER //
// ./src/_components/divider/index.js